import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../../../../components/Header';
import FooterTwo from '../../../../components/Footer';
import './AqarReports.scss';
import PageBanner from '../../../../components/PageBanner';

import { mediaUrl } from '../../../../services/assetUrl';

const API_BASE = process.env.REACT_APP_DATABASEURL || '';

const AqarSupportingDocsSection = ({ table, isActive, onToggle }) => {
  const [activeCategory, setActiveCategory] = React.useState(table.rows[0]?.category);

  React.useEffect(() => {
    if (isActive && table.rows.length > 0) {
      setActiveCategory(table.rows[0].category);
    }
  }, [isActive, table]);

  const activeRow = table.rows.find(row => row.category === activeCategory) || table.rows[0];

  return (
    <div className={`aqar-accordion-item ${isActive ? 'is-active' : ''}`}>
      <button 
        className="aqar-accordion-header"
        onClick={onToggle}
        aria-expanded={isActive}
      >
        <div className="aqar-accordion-header__left">
          {/* We can use a generic icon or number for the badge, here we use an icon */}
          <span className="aqar-accordion-badge">
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" style={{width: '16px', height: '16px'}}>
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
            </svg>
          </span>
          <h2 className="aqar-accordion-title">{table.title}</h2>
        </div>
        <div className="aqar-accordion-header__right">
          <svg 
            className={`aqar-accordion-icon ${isActive ? 'rotate' : ''}`} 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </button>

      {isActive && (
        <div className="aqar-accordion-body tab-fade-in p-6 bg-white">
          {/* Glass UI Tabs */}
          <div className="aqar-tabs-container">
            {table.rows.map((row) => (
              <button
                key={row.category}
                onClick={() => setActiveCategory(row.category)}
                className={`aqar-tab ${activeCategory === row.category ? 'aqar-tab--active' : ''}`}
              >
                Criteria {row.category}
              </button>
            ))}
          </div>

          {/* Active Tab Content - Carousel */}
          <div className="aqar-carousel">
            {activeRow?.links.map((link, linkIndex) => (
              <div key={linkIndex} className="aqar-carousel-item">
                <span className="aqar-carousel-item__year">{link.text}</span>
                {link.href ? (
                  <a
                    href={mediaUrl(link.href)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="aqar-carousel-item__link"
                    title="View PDF"
                  >
                    <svg className="aqar-carousel-item__icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"></path>
                    </svg>
                    <span>View Document</span>
                  </a>
                ) : (
                  <span className="aqar-carousel-item__link aqar-carousel-item__link--disabled">
                    <span>Updating Soon</span>
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const AqarReports = () => {
  const [activeTableId, setActiveTableId] = React.useState(null);
  const [aqarData, setAqarData] = useState({ reports: [], tables: [] });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await axios.get(`${API_BASE}api/iqac-details/aqar`);
        const data = res?.data?.data?.data;
        if (active && data) setAqarData({ reports: data.reports || [], tables: data.tables || [] });
      } catch (e) {
        // leave empty on failure
      }
    })();
    return () => { active = false; };
  }, []);

  return (
    <div className="aqar-page">
      <Header />
      {/* Hero Section */}
      <PageBanner
        title="AQAR Reports"
        eyebrow="QUALITY ASSURANCE"
        subtitle="ANNUAL QUALITY ASSURANCE REPORTS & SUPPORTING DOCUMENTS"
      >
        <div style={{ marginTop: '32px' }}>
          <a href="/iqac" className="aqar-hero__btn" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '12px 24px', backgroundColor: '#F6872A', color: 'white', borderRadius: '8px', fontWeight: 'bold', textDecoration: 'none' }}>
            <svg style={{ width: '20px', height: '20px' }} fill="currentColor" viewBox="0 0 20 20">
              <path d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z"></path>
            </svg>
            View Full IQAC Overview
          </a>
        </div>
      </PageBanner>

      {/* Main Content */}
      <div className="aqar-main">
        
        {/* Intro Note */}
        <div className="aqar-intro">
          <p>
            The Annual Quality Assurance Report (AQAR) is a yearly self-review report of the institution's quality enhancement initiatives. Below you can find the complete reports and supporting documentation for each academic cycle.
          </p>
        </div>

        {/* Annual Reports Section - Creative Vertical Timeline */}
        <div className="aqar-timeline-section">
          <div className="aqar-timeline-header">
            <div className="aqar-timeline-header__indicator"></div>
            <h2 className="aqar-timeline-header__title">
              Academic Timeline
            </h2>
          </div>

          <div className="aqar-timeline">
            {aqarData.reports.map((report, idx) => {
              const yearMatch = report.title.match(/(\d{4}-\d{4}|\d{4}-\d{2})/);
              const yearText = yearMatch ? yearMatch[0] : report.title;
              const isAvailable = report.type === 'link';

              return (
                <div key={idx} className={`aqar-timeline-item ${isAvailable ? 'is-available' : 'is-pending'}`}>
                  {/* Timeline Node */}
                  <div className="aqar-timeline-node"></div>

                  {/* Card Content */}
                  <div className="aqar-timeline-card">
                    {/* Decorative Background Element */}
                    {isAvailable && <div className="aqar-timeline-card__glow"></div>}

                    <div className="aqar-timeline-card__content">
                      <div className="aqar-timeline-card__left">
                        <span className="aqar-timeline-card__badge">
                          Academic Year
                        </span>
                        <h3 className="aqar-timeline-card__year">{yearText}</h3>
                        <p className="aqar-timeline-card__desc">Annual Quality Assurance Report submitted to NAAC</p>
                      </div>

                      <div className="aqar-timeline-card__right">
                        {isAvailable ? (
                          <a href={mediaUrl(report.link)} target="_blank" rel="noreferrer" className="aqar-timeline-btn">
                            <svg className="aqar-timeline-btn__icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                            </svg>
                            View Full Report
                          </a>
                        ) : (
                          <div className="aqar-timeline-btn aqar-timeline-btn--disabled">
                            <svg className="aqar-timeline-btn__icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                            </svg>
                            {report.status}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Supporting Documents Section */}
        <div className="aqar-section">
          <div className="aqar-section__header">
            <div className="aqar-section__indicator"></div>
            <h2 className="aqar-section__title">
              Supporting Documents
            </h2>
          </div>
          
          <div className="aqar-accordion-list">
            {aqarData.tables && aqarData.tables.map((table, tIdx) => (
              <AqarSupportingDocsSection 
                key={tIdx} 
                table={table} 
                isActive={activeTableId === tIdx}
                onToggle={() => setActiveTableId(activeTableId === tIdx ? null : tIdx)}
              />
            ))}
          </div>
        </div>
      </div>
      <FooterTwo />
    </div>
  );
};

export default AqarReports;
